import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 
import styles from './styles/AdminPanel.module.css'; 

export const AdminPanel = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate(); 

  const API_BASE = "https://xenorize.com/api";

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${API_BASE}/users/`);
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };
    fetchUsers();
  }, []);

  const handleEdit = (userId) => {
    navigate(`/user-edit/${userId}`); 
  };

  const handleDelete = async (userId) => {
    try {
      await axios.delete(`${API_BASE}/users/${userId}`);
      setUsers(users.filter(user => user.user_id !== userId)); 
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  const handleToggleSuspend = async (userId, currentStatus) => {
    try {
      const newStatus = !currentStatus;
      await axios.put(`${API_BASE}/users/${userId}/suspend`, { suspend_status: newStatus });
      const response = await axios.get(`${API_BASE}/users`);
      setUsers(response.data);  
    } catch (error) {
      console.error('Error toggling suspension status:', error);
    }
  };
  
  const handleAddUser = () => {
    navigate('/user-add'); 
  };

  const handleSubscriptionDetails = (stripeCustomerId) => {
    console.log("Navigating to subscription details:", stripeCustomerId); 
    navigate(`/subscription-details/${stripeCustomerId}`);
  };
  
  return (
    <div className={styles.adminPanel}>
      <h1>Admin Panel</h1>
      <button className={styles.addUserButton} onClick={handleAddUser}>Add User</button>
      <table className={styles.userTable}>
        <thead>
          <tr>
            <th>User ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.user_id}>
              <td>{user.user_id}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>
                {user.suspend_status ? (
                  <span className={styles.suspendedStatus}>Suspended</span>
                ) : (
                  <span className={styles.activeStatus}>Active</span>
                )}
              </td>
              <td>
                <button className={styles.editButton} onClick={() => handleEdit(user.user_id)}>Edit</button>
                <button className={styles.deleteButton} onClick={() => handleDelete(user.user_id)}>Delete</button>
                {user.suspend_status ? (
                  <button
                    className={styles.unsuspendButton}
                    onClick={() => handleToggleSuspend(user.user_id, user.suspend_status)}
                  >
                    Unsuspend
                  </button>
                ) : (
                  <button
                    className={styles.suspendButton}
                    onClick={() => handleToggleSuspend(user.user_id, user.suspend_status)}
                  >
                    Suspend
                  </button>
                )}
                  <button
                    className={styles.subscriptionButton}
                    onClick={() => handleSubscriptionDetails(user.stripe_customer_id)}
                  >
                    Subscription Details
                  </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
